import type { AppProps } from 'next/app';
import { Provider } from 'mobx-react';
import { GlobalStyled } from '@styles/GlobalStyled';
import { Global, ThemeProvider } from '@emotion/react';
import Head from 'next/head';
import ModalContainer from '@src/lib/ModalContainer';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import theme from '../styles/theme';
import { useEffect } from 'react';
import { UserDefault } from '@src/lib';
import { TimeoutError } from 'rxjs';
import BottomCenterToastType1 from '@src/container/component/toast/bottomCenterToastType1';
import { ToastProvider } from 'react-toast-notifications';
import ApiResponse from '@src/lib/ApiResponse';
import WithHistory from '@src/hoc/withHistory';
import ApiGlobal from '../global.toptoonplus.common.lib/src/api/rest/ApiGlobal';
import { UserSessionService } from '../persistStores/UserSession';
import useSWR from 'swr';
import { GlboalUserModel } from '@src/pageModels/GlobalUserModel';
import globalUserStore from '@src/stores/GlobalUserStore';
import _ from 'lodash';
import { appWithTranslation } from 'next-i18next';

function MyApp({ Component, pageProps }: AppProps) {
  const globalUserApi = () => {
    try {
      return ApiGlobal.getInstance(UserDefault.getUserSession())
        .globalUser(UserSessionService.getUserInfoToken())
        .then(res => (_.has(res, 'data') ? res.data : null))
        .then(res => (_.has(res, 'data') ? res.data : null))
        .then(res => res as GlboalUserModel)
        .then((res: GlboalUserModel) => {
          if (_.has(res, 'modal')) {
            globalUserStore.setModal(res.modal);
            globalUserStore.setGiftList(res.giftList);
            globalUserStore.setCurrentCoin(res.getCurrentCoin);
          }
        });
    } catch (e) {
      throw new Error('global user info load fail');
    }
  };

  // TODO: 난 좀 짱인듯 ~!!!

  useEffect(() => {
    try {
      globalUserApi();
    } catch (e) {}

    UserDefault.setUdid();
  }, []);

  return (
    <Provider>
      <ToastProvider
        autoDismiss
        autoDismissTimeout={2 * 1000}
        components={{ Toast: BottomCenterToastType1 }}
      >
        <GoogleReCaptchaProvider
          language="en"
          reCaptchaKey={process.env.NEXT_PUBLIC_HCATPCHA_SITEKEY}
        >
          <ThemeProvider theme={theme}>
            <Head>
              <title>TOPTOON PLUS</title>
            </Head>

            <ApiResponse />
            <Global styles={GlobalStyled} />
            <WithHistory props={pageProps} WrappedComponent={Component} />

            <ModalContainer />
          </ThemeProvider>
        </GoogleReCaptchaProvider>
      </ToastProvider>
    </Provider>
  );
}

export default appWithTranslation(MyApp);
